<div class="gl-page">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Grootboekrekening</h1>

    <div class="gl-page__header-actions">
      <yds-button variant="primary" (click)="navigateToCreate()">
        Grootboekrekening toevoegen
      </yds-button>
    </div>
  </div>

  <div class="gl-page__filter">
    @if (isLoadingLedgers()) {
      <div class="gl-list-state">
        <yds-spinner [label]="'Grootboeken laden...'" />
      </div>
    } @else if (generalLedgers().length === 0) {
      <yds-empty-states [message]="'Er zijn nog geen grootboeken'" />
    } @else {
      <yds-dropdown
        label="Grootboek"
        [items]="generalLedgerOptions()"
        [allowClear]="false"
        [value]="generalLedgerId()"
        (valueChange)="onGeneralLedgerChange($event)"
      />
    }
  </div>

  @if (!isLoadingLedgers() && generalLedgers().length > 0) {
    @if (isLoading()) {
      <yds-card>
        <div class="gl-list-state">
          <yds-spinner [label]="'Grootboekrekeningen laden...'" />
        </div>
      </yds-card>
    } @else if (tableItems().length === 0) {
      <yds-empty-states [message]="'Er zijn nog geen Grootboekrekeningen'" />
    } @else {
      <yds-card>
        <div class="gl-list-table">
          <yds-table
            [embedded]="true"
            [showPaginationFooter]="accounts().length > 0"
            [columns]="tableColumns"
            [items]="tableItems()"
            [zebra]="true"
            [dottedColumns]="true"
            [clickable]="true"
            (rowClick)="onTableRowClick($event)"
          >
            <ng-template ydsTableCell="actions" let-item="item">
              <yds-split-button
                label="Bekijk details"
                [items]="splitButtonItems"
                variant="default"
                size="sm"
                (mainClick)="viewItem(item.id, $event)"
                (itemClick)="handleActionClick(item.id, $event)"
              ></yds-split-button>
            </ng-template>

            @if (accounts().length > 0) {
              <yds-pagination
                pagination
                [(pageIndex)]="pageIndex"
                [pageSize]="pageSize"
                [totalItems]="accounts().length"
              />
            }
          </yds-table>
        </div>
      </yds-card>
    }
  }
</div>
